module.exports = __webpack_public_path__ + "img/edgeguard-logo.25491ba9.png";